module.exports = __webpack_public_path__ + "assets/img/33_1578_big.55c610c9.jpg";